const initialState = {
  fullScreenComponentType: undefined,
};
  
export default initialState;
  
